import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
// SERVICES
import { AnswerService } from '@services/answer/answer.service';
import { QuestionBankService } from '@services/question-bank/question-bank.service';
import { AlertService } from '@services/notification/alert.service';
// MODELS
import { AnswerBase } from '../answer-base';

@Component({
  selector: 'app-open-answer',
  templateUrl: './open-answer.component.html',
  styleUrls: ['./open-answer.component.scss']
})
export class OpenAnswerComponent extends AnswerBase {

  constructor(
    fb: FormBuilder,
    alertService: AlertService,
    answerService: AnswerService,
    questionBankService: QuestionBankService,
  ) {
    super(fb, alertService, answerService, questionBankService)
  }

  finishLoadData() {
    if (this.formAnswers.length === 0) {
      this.addNewAnswer();
    }
  }


}
